let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("i5EJc"), load("8qpSy")]).then(() => parcelRequire('9wKGM'));